/**
 * EAA-1670: query-key factory for the permissions domain (Phase 7 state migration).
 * Keyed by user id so a new session (post-login/session-restore) never serves a
 * stale cache entry from a previous subject.
 * See docs/plans/fe-restructure/phase-7-state-migration.md.
 */

export const permissionsKeys = {
    all: ['permissions'] as const,
    /*
     * EAA-1842: the acting tenant is part of the identity of this read, not a
     * detail of how it is fetched. `GET /permissions/effective/` resolves the set
     * from `X-Tenant-Id`, and a member of several tenants holds a DIFFERENT set in
     * each (sys-viewer in one, sys-editor in another) — so a key without the tenant
     * served the first tenant's codes for every later one, and never refetched when
     * the switcher moved.
     */
    effective: (userId?: string, tenantId?: string | null) =>
        [...permissionsKeys.all, 'effective', userId, tenantId ?? null] as const,
    // Screen rules are platform-wide (the backend merges one table for every
    // caller), so they are NOT tenant-scoped — keying them by tenant would refetch
    // identical data on every switch.
    screenRules: (userId?: string) => [...permissionsKeys.all, 'screenRules', userId] as const,
};
